import axios from 'axios';

export const chatAPI = axios.create({
    baseURL: ''
});
